import { render } from "./MoreSvg.vue?vue&type=template&id=2ebbd606"
const script = {}
script.render = render

export default script